// TD-2192 — "You can try again in M:SS." under the backend's MFA lock text.
//
// The backend text always says 5 minutes; this shows the real time left on
// the server's lock (authStore.mfaCodeLockedUntil, from retryAfterSeconds).
// Renders nothing while there is no lock, and ends the lock in the store once
// its time is up. No aria-live: the lock text is
// already announced, and a per-second announcement would flood screen readers.

import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useStore } from '../../../../store/store';

const formatRemaining = (ms) => {
  const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = String(totalSeconds % 60).padStart(2, '0');
  return `${minutes}:${seconds}`;
};

const MfaLockCountdown = observer(() => {
  const { authStore } = useStore();
  const lockedUntil = authStore.mfaCodeLockedUntil;
  const [now, setNow] = useState(() => Date.now());

  // Each tick also ends the lock once its time is up, in case the store's
  // timer fires late (laptop sleep, background tab).
  useEffect(() => {
    if (!lockedUntil) return undefined;
    const tick = () => {
      setNow(Date.now());
      authStore.releaseMfaCodeLockIfExpired();
    };
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, [authStore, lockedUntil]);

  if (!lockedUntil) return null;

  return (
    <div className="small mt-2">You can try again in {formatRemaining(lockedUntil - now)}.</div>
  );
});

export default MfaLockCountdown;
